import React, { Component } from 'react'
import PropTypes from "prop-types";
import ChartSection from './ChartSection';
import HourPriceLineGraph from './Charts/HourPriceLineGraph';

class HourPricesGraphSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      posts: this.props.dataProps,
      postsPerPage: 1,
    };
  }


  render() {
    const { title, description, dataProps, options, prevIcon, nextIcon, prevHoverIcon, nextHoverIcon, plugins } = this.props;
    //Get currentPosts
    const indexOfLastPost = this.state.currentPage * this.state.postsPerPage;
    const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
    const currentPosts = this.state.posts.filter(item => item.data['labels'] !== undefined).slice(indexOfFirstPost, indexOfLastPost);

    if (dataProps === undefined || !dataProps) {
      return null
    }

    let numbers = currentPosts.map(item => item.data.datasets.length === 0 ? 0 : parseInt(item.data.quality));

    const nextQuestion = () => {
      if (this.state.currentPage <= Math.ceil(this.state.posts.filter(item => item.data['labels'] !== undefined).length - 1 / this.state.postsPerPage) && (numbers.toString() === [this.state.currentPage].toString())) {
        this.setState({ currentPage: this.state.currentPage + 1 });
      } else {
        this.setState({ currentPage: this.state.currentPage });
      }
    }

    const previousQuestion = () => {
      this.setState({ currentPage: Math.max(this.state.currentPage - 1, 1) });
    }

    return (
      <ChartSection
        title={title}
        description={description}
        component={
          <nav aria-label="quality" className='col-12 col-md-12 col-xl-8'>
            <ul class="d-flex flex-column flex-md-row justify-content-evenly  align-items-center" style={{ paddingLeft: "0px " }}>
              <p className='pine subtitle' style={{
                fontWeight: 700,
                padding: "1rem 0rem",
                margin: "0rem 1rem"
              }}>Välj kvalité</p>
              <div className='d-flex flex-row justify-content-between align-items-center'>
                <a
                  className="btn-text"
                  onClick={previousQuestion}
                  style={{ width: "100px", cursor: "pointer"  }}
                >
                  <img
                    src={prevIcon}
                    style={{ width: "51px" }}
                    //onMouseOver={e => e.currentTarget.src = prevHoverIcon}
                    //onMouseOut={e => (e.currentTarget.src = prevIcon)} 
                  />
                </a>

                <p className='neutral-charcoal px-3 my-3'>{this.state.currentPage}</p>
                <a
                  className="btn-text"
                  onClick={nextQuestion}
                  style={{ width: "100px", cursor: "pointer"  }}
                >
                  <img
                    src={nextIcon}
                    style={{ width: "51px" }}
                    //onMouseOver={e => e.currentTarget.src = nextHoverIcon}
                    //</a>onMouseOut={e => (e.currentTarget.src = nextIcon)}

                    />
                </a>
              </div>
            </ul>
          </nav>
        }
      >
        {currentPosts.map((item) => item.data['datasets'].length !== 0 ? <HourPriceLineGraph  options={options} data={item.data} plugins={plugins} quality={item.quality} /> : <div className='d-flex flex-row justify-content-center'><p className='neutral-charcoal'>No availble data for this quallity</p></div>)}
      </ChartSection >

    );
  }
}

HourPricesGraphSection.propTypes = {
  title: PropTypes.shape({}),
  description: PropTypes.shape({}),
  dataProps: PropTypes.arrayOf(PropTypes.shape({})),
  options: PropTypes.shape({}),
  plugins: PropTypes.arrayOf({}),
};

HourPricesGraphSection.defaultProps = {
  title: undefined,
  plugins: undefined,
  description: undefined,
  dataProps: undefined,
  options: undefined
}


export default HourPricesGraphSection;